<template>
	<div :class="added ? 'active' : ''" class="fake-container">
		<div class="activite individuelle key">
			<div @click="checkRights()" class="exo" ref="imgContainer"></div>
		</div>
		<div class="add-container add-container-key">
			<div>
				<p>{{ title }}</p>
			</div>
			<button @click="popUp" class="submit add">
				<span>Enregistrer</span>
			</button>
		</div>
	</div>
	<slider-key
		@addKey="addKey"
		@close="showPopUpSlide = !showPopUpSlide"
		v-if="showPopUpSlide"
		:image1="image1"
		:image2="image2"
		:image3="image3"
		:image4="image4"
		:image5="image5"
		:image6="image6"
		:image7="image7"
		:image8="image8"
		:image9="image9"
		:image10="image10"
		:notice="notice"
	/>
	<pop-up-key v-if="isPopUpVisible" :id="index" @close="popUp" />
</template>

<script>
import { authenticatedImageFetch, checkRightFor } from "../../../utils/utils";
import PopUpKey from "../../PopUp/PopUpKey.vue";
import SliderKey from "./SliderKey.vue";
export default {
	components: { SliderKey, PopUpKey },
	props: {
		index: Number,
		title: String,
		description: String,
		chapter: String,
		image1: String,
		image2: String,
		image3: String,
		image4: String,
		image5: String,
		image6: String,
		image7: String,
		image8: String,
		image9: String,
		image10: String,
		guest_visible: Boolean,
		notice: String
	},
	data() {
		return {
			added: false,
			readyToDisplay: false,
			isPopUpVisible: false,
			showPopUpSlide: false,
			isVisibleGuest: false
		};
	},
	methods: {
		checkRights() {
			if (!checkRightFor("Activités Expresso", [])) {
				this.$store.state.isPopUpNotAllowedVisible = true;
				return;
			}
			this.showPopUpSlide = !this.showPopUpSlide;
		},
		addKey() {
			if (!checkRightFor("Activités Expresso", [])) {
				this.$store.state.isPopUpNotAllowedVisible = true;
				return;
			}
			this.showPopUpSlide = false;
			this.isPopUpVisible = true;
		},

		getImage() {
			authenticatedImageFetch(this.image1, {
				method: "GET"
			})
				.then(response => response.blob())
				.then(blob => {
					const reader = new FileReader();
					const component = this;
					reader.onload = function() {
						const img = new Image();
						img.src = this.result;
					if (component.$refs.imgContainer) {
						component.$refs.imgContainer.append(img);
					}
					};
					reader.readAsDataURL(blob);
				});
		},
		popUp() {
			if (!checkRightFor("Activités Expresso", [])) {
				this.$store.state.isPopUpNotAllowedVisible = true;
				return;
			}
			this.isPopUpVisible = !this.isPopUpVisible;
		},
		timeToCloseGuest() {
			this.isVisibleGuest = false;
		},
		reRender() {
			if (window.MathJax.typesetPromise) {
				window.MathJax.typesetPromise();
			}
		}
	},
	created() {
		this.reRender();
	},
	mounted() {
		this.reRender();
		setTimeout(() => {
			this.readyToDisplay = true;
		}, 1000);

		if (this.image1 !== null) {
			this.getImage();
		}
	}
};
</script>

<style></style>
